export class LocalDataCookieModel {
  countryId: Number;
  defaultLangID: Number;

  constructor(cookie: Object) {
    this.countryId = cookie.countryId;
    this.defaultLangID = cookie.defaultLangID;
  }
}
